import React from 'react';

class FormBuilder_FieldEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editing: false,

      field: this.props.field || {}
    };

    // this.setEditMode = this.setEditMode.bind(this);

    this.handleUpdateLabel = this.handleUpdateLabel.bind(this);
    this.handleUpdateType = this.handleUpdateType.bind(this);

    this.handleAddOption = this.handleAddOption.bind(this);
    this.handleUpdateOptionLabel = this.handleUpdateOptionLabel.bind(this);
    this.handleUpdateOptionValue = this.handleUpdateOptionValue.bind(this);
    this.handleRemoveOption = this.handleRemoveOption.bind(this);

    this.handleHelpUpdate = this.handleHelpUpdate.bind(this);

    this.handleChange = this.handleChange.bind(this);
    // this.handleCancel = this.handleCancel.bind(this);
    // this.handleSave = this.handleSave.bind(this);
  }

  handleUpdateLabel(e) {
    const value = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.field.label = value;

      return prevState;
    }, () => {
      this.handleChange();
    });
  }
  handleUpdateType(e) {
    const value = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.field.type = value;
      prevState.field.options = [];

      return prevState;
    }, () => {
      this.handleChange();
    });
  }

  handleAddOption(e) {
    this.setState((prevState) => {
      prevState.field.options.push({
        label: '',
        value: ''
      });

      return prevState;
    }, () => {
      this.handleChange();
    });
  }

  handleUpdateOptionLabel(i, e) {
    const value = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.field.options[i].label = value;

      return prevState;
    }, () => {
      this.handleChange();
    });
  }

  handleUpdateOptionValue(i, e) {
    const value = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.field.options[i].value = value;

      return prevState;
    }, () => {
      this.handleChange();
    });
  }

  handleRemoveOption(i) {
    this.setState((prevState) => {
      prevState.field.options.splice(i, 1);

      return prevState;
    }, () => {
      this.handleChange();
    });
  }

  handleHelpUpdate(e) {
    const value = e.currentTarget.value;

    this.setState((prevState) => {
      prevState.field.help = value;

      return prevState;
    }, () => {
      this.handleChange();
    });
  }

  handleChange() {
    if (!this.state.field.name) {
      alert('no name!');

      return;
    }
    if (this.props.onChange) {
      this.props.onChange(this.state.field);
    }
  }

  // handleCancel() {
  //   if (this.props.onCancel !== undefined) {
  //     this.props.onCancel();
  //   } else {
  //     alert('Would cancel, but not know what to do');
  //   }
  // }
  // handleSave() {
  //   alert('save!');

  //   if (this.props.onSave !== undefined) {
  //     this.props.onSave();
  //   } else {
  //     alert('Would save, but not know what to do');
  //   }
  // }

  render() {
    return (
      <table width="100%" border="0" className="mb-4">
        <tr>
          <td>
            <div className="card">
              <div className="card-body">
                <div className="mb-4">
                  <label>Testo:</label> <input type="text" className="form-control" onChange={this.handleUpdateLabel} value={this.state.field.label} />
                </div>

                <div className="mb-4">
                  <label>Tipologia:</label>
                  <select className="form-control" onChange={this.handleUpdateType} value={this.state.field.type}>
                    <option value="text">Testo</option>
                    <option value="textarea">Textarea</option>
                    <option value="select">Select</option>
                  </select>

                  {
                    this.state.field.type == 'select' && (
                      <div className="mt-2">
                        <label><small>Opzioni:</small></label>
                        {
                          this.state.field.options.map((option, i) => {
                            const n = i+1;

                            return (
                              <table border="0" witdth="100%" className="mb-2">
                                <tr>
                                  <th width="5%"></th>
                                  <th width="30%" ><small>Valore</small></th>
                                  <th width="60%"><small>Descrizione</small></th>
                                  <th width="5%"></th>
                                </tr>
                                <tr>
                                  <td valign="middle">{n}</td>
                                  <td valign="middle" style={{paddingRight: '2%'}}>
                                    <input type="text" value={this.state.field.options[i].value} className="form-control" onChange={(e) => this.handleUpdateOptionValue(i, e)} />
                                  </td>
                                  <td valign="middle" style={{paddingRight: '2%'}}>
                                    <input type="text" value={this.state.field.options[i].label} className="form-control" onChange={(e) => this.handleUpdateOptionLabel(i, e)} />
                                  </td>
                                  <td valign="middle">
                                    <button className="btn btn-secondary" onClick={(e) => this.handleRemoveOption(i, e)}><i className="fa fa-times" /></button>
                                  </td>
                                </tr>
                              </table>
                            );
                          })
                        }

                        <p className="mt-3"><button className="btn btn-sm" onClick={this.handleAddOption}><i className="fa fa-plus" /> aggiungi opzione</button></p>
                      </div>
                    )
                  }
                </div>

                <div className="mb-4">
                  <label>Istruzioni aggiuntive:</label>

                  <input type="text" className="form-control" value={this.state.field.help} onChange={this.handleHelpUpdate} />
                </div>
              </div>
            </div>
          </td>
          <td width="200px" align="center" valign="middle" className="pl-4">
          <div>
            {/* <button className="btn btn-primary" onClick={this.handleSave}><i className="fa fa-save mr-1" /> salva</button><br />
            <small className="ml-2 mr-2">oppure</small><br />
            <a href="javascript:void(0)" onClick={() => {
              if (window.confirm('Sicura di cancellare?')) {
                this.handleCancel(false);
              }
            }}>cancella</a> */}
          </div>
          </td>
        </tr>
      </table>
    );
  }
}

export default FormBuilder_FieldEditor;


// WEBPACK FOOTER //
// ./src/components/marketing/surveys/form_builder/FormBuilder_FieldEditor.js